import { useNavigate } from "react-router-dom";
import { IoMdArrowBack } from "react-icons/io";

import toast from "react-hot-toast";
import { useEffect, useState } from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { createPin, getPrivateHas } from "../../redux/ApiSlice/AccountPrivateSlice";

const PrivateCreate = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [password, setPassword] = useState({ pin: "" });
    const [showPassword, setShowPassword] = useState(false);

    const createPinStatus = useSelector((state) => state.AccountPrivate);

    const handleChange = (e) => {
        setPassword({ [e.target.name]: e.target.value });
    };

    const handleShowPassword = () => {
        setShowPassword(!showPassword);
    }

    const submitPassword = async () => {
        if (password.pin.length < 6) {
            return toast.error("Password must be 6 digits");
        }
        if (isNaN(password.pin)) {
            return toast.error("Password must be a number");
        }
        try {
            const result = await dispatch(createPin(password));
            if (result.payload?.message === "PIN created successfully.") {
                toast.success("Password created successfully.");
                dispatch(getPrivateHas());
                setTimeout(() => {
                    navigate("/private");
                }, 2000);
            } else {
                toast.error(result.payload.error || "Failed to create password");
            }
        } catch (error) {
            toast.error(error.error || "Failed to create password");
        }
    };

    useEffect(() => {
        return () => setPassword({ pin: "" });
    }, []);

    return (
        <>
            {/* Header */}
            <div className="sticky top-0 z-10">
                <div className="relative bg-[#BDE6FF] rounded-b-xl h-12 flex items-center justify-center">
                    <IoMdArrowBack
                        onClick={() => navigate("/private/empty")}
                        className="absolute left-2 top-1/2 transform -translate-y-1/2 text-[22px] text-black dark:text-black cursor-pointer"
                    />
                    <p className="font-bold text-[18px] text-black dark:text-black line-clamp-1">Create Private PIN</p>
                </div>
            </div>

            <div className="h-full flex flex-col bg-white dark:bg-[#1E1D21] px-4">
                <p className="text-center mt-5 mb-2 text-gray-600 dark:text-gray-400 text-sm">
                    Set up a 6-digit PIN to secure your private videos
                </p>

                {/* PIN Input Card */}
                <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-xl p-8 border border-gray-200 dark:border-gray-700">
                    <input
                        name="pin"
                        maxLength={6}
                        id="grid-last-name"
                        value={password.pin}
                        onChange={handleChange}
                        placeholder="Enter 6 digit PIN"
                        type={showPassword ? "text" : "password"}
                        className="w-full h-10 px-4 bg-gray-100 dark:bg-gray-700 rounded-xl text-center text-black dark:text-white focus:outline-none text-[14px] font-semibold"
                    />

                    <div className="flex justify-center my-4">
                        <button
                            type="button"
                            onClick={handleShowPassword}
                            className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
                        >
                            {showPassword ? <FiEye size={18} /> : <FiEyeOff size={18} />}
                            <span>{showPassword ? 'Hide PIN' : 'Show PIN'}</span>
                        </button>
                    </div>

                    {/* Submit Button */}
                    <button
                        type="button"
                        onClick={submitPassword}
                        disabled={createPinStatus.loading}
                        className="mt-8 w-full max-w-xs h-10 rounded-xl bg-[#BDE6FF] flex items-center justify-center gap-2 text-black border border-black font-bold text-[14px]"
                    >
                        {createPinStatus.loading ? (
                            <div className="flex items-center gap-3">
                                <div className="relative w-5 h-5">
                                    <div className="absolute inset-0 border-2 border-white/30 rounded-full"></div>
                                    <div className="absolute inset-0 border-2 border-t-white rounded-full animate-spin"></div>
                                </div>
                                <span>Creating...</span>
                            </div>
                        ) : (
                            <span>Confirm & Create</span>
                        )}
                    </button>
                </div>

                {/* Info Section */}
                <div className="mt-6 bg-blue-50 dark:bg-blue-900/20 rounded-xl p-4 border border-blue-200 dark:border-blue-800">
                    <div className="flex items-start gap-3">
                        <svg className="w-5 h-5 text-blue-600 dark:text-blue-400 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <div>
                            <p className="text-sm font-semibold text-blue-900 dark:text-blue-300 mb-1">
                                Security Tips
                            </p>
                            <ul className="text-xs text-blue-800 dark:text-blue-400 space-y-1">
                                <li>• Use a unique 6-digit PIN</li>
                                <li>• Don't share your PIN with anyone</li>
                                <li>• Remember your PIN - you'll need it to access private videos</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PrivateCreate;
